import React from 'react'

import Implemento from 'entity/Implemento'
import SeletorCliente from 'entity/Cliente/components/SeletorCliente'

import DefaultEntityCrud from 'components/form/DefaultEntityCrud'
import FormContent from 'components/form/FormContent'
import TextInput from 'components/form/input/TextInput'
import SelectInput from 'components/form/input/SelectInput'
import FormRow from 'components/form/FormRow'


function ImplementoFormInter(props) {
    return (
        <FormContent sx={{ p: 2 }}>
            <FormRow>
                <TextInput
                    sx={{ flex: 0.5 }}
                    name="sequencialIndex"
                    label="Código"
                    InputLabelProps={{
                        shrink: true,
                    }}
                    type="number"
                    disabled
                />
                <SelectInput
                    sx={{ flex: 0.5 }}
                    name="status"
                    label="Status"
                    options={["ATIVO", "INATIVO"]}
                    required
                />
                <SeletorCliente
                    sx={{ flex: 2 }}
                    InputLabelProps={{
                        shrink: true,
                    }}
                    required
                />
            </FormRow>

            <FormRow>
                <TextInput
                    sx={{ flex: 0.25 }}
                    name="numeroFrotaImplemento"
                    label="nº Frota"
                    InputLabelProps={{
                        shrink: true,
                    }}
                    required
                />
                <TextInput
                    sx={{ flex: 0.5 }}
                    name="marcaImplemento"
                    label="Marca"
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
                <TextInput
                    sx={{ flex: 0.5 }}
                    name="nomeImplemento"
                    label="Implemento"
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
                <TextInput
                    sx={{ flex: 0.5 }}
                    name="modeloImplemento"
                    label="Operador"
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
            </FormRow>
        </FormContent>
    )
}

export default function ImplementoForm() {
    return (
        <DefaultEntityCrud
            title={"Cadastro de Implemento"}
            EntityClass={Implemento}
            routeForm={"_implemento"}
            backRoute="consulta-implemento"

            formActions={{ novoForm: false, salvarForm: true, sairForm: true }}
        >
            {(props) => <ImplementoFormInter {...props} />}
        </DefaultEntityCrud>
    )
}
